var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.861,
    height: 25,
    viewBox: "0 0 29.861 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3416",
    "data-name": "Path 3416",
    d: "M-877.445,122.453c.724,0,1.443,0,2.162,0a1.317,1.317,0,0,1,1.462,1.461q0,9.2,0,18.393a1.34,1.34,0,0,1-1.467,1.472q-11.64,0-23.281,0a1.371,1.371,0,0,1-1.457-1.457c.037-.718.007-1.439.007-2.2-.119-.006-.222-.015-.325-.016-.662,0-1.323,0-1.984,0a1.3,1.3,0,0,1-1.353-1.366q0-9.271,0-18.541a1.323,1.323,0,0,1,1.424-1.421q6.19,0,12.381,0h10.9a1.332,1.332,0,0,1,1.492,1.495q0,1.037.006,2.073A.548.548,0,0,0-877.445,122.453Zm-20.122,2.447v16.429h21.3V124.9Zm-2.451,12.775v-.318q0-1.822,0-3.643,0-4.946,0-9.893A1.264,1.264,0,0,1-899,122.488a2.522,2.522,0,0,1,.559-.034q9.049,0,18.1,0h.4v-1.21h-21.292v16.431Z",
    transform: "translate(903.681 -118.784)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3417",
    "data-name": "Path 3417",
    d: "M-761.058,311.167H-779.92l1.316-1.9q1.67-2.407,3.34-4.813c.393-.565.735-.573,1.157-.024.535.7,1.064,1.4,1.6,2.1.368.483.718.48,1.089-.008l3.96-5.207c.036-.047.074-.093.111-.139.342-.424.677-.422,1.011.015.49.643.975,1.291,1.463,1.937q1.8,2.387,3.6,4.771a.978.978,0,0,1,.213.647c-.011.76,0,1.521,0,2.281C-761.057,310.931-761.058,311.038-761.058,311.167Z",
    transform: "translate(787.253 -290.07)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3418",
    "data-name": "Path 3418",
    d: "M-746.533,246.682a2.122,2.122,0,0,1,2.123,2.151,2.148,2.148,0,0,1-2.139,2.115,2.149,2.149,0,0,1-2.124-2.161A2.127,2.127,0,0,1-746.533,246.682Z",
    transform: "translate(757.859 -239.104)",
    fill: "#9f9f9f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group 17.cd08bdb07a7b5afa4d79c658d9858eab.svg";
export { ForwardRef as ReactComponent };